import React from "react";
import { Route } from "react-router-dom";
import Customers from "../components/Customers/Customers";
import MainLayout from "../layouts/MainLayout";

export const customersRoutes = [
    <Route key="customers" path="/customers" element={<MainLayout />}>
        <Route index element={<Customers />} />
    </Route>,
];
